import React from "react"
import PropTypes from "prop-types"
import { Button } from "reactstrap"
import { LazyLoadImage } from "react-lazy-load-image-component"
import Icon from "./Icon"
import { useDispatch, useSelector } from "react-redux"
import { setActiveSlide } from "store/lightbox"

PreviewMedia.propTypes = {
  preview: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  ratio: PropTypes.string,
  type: PropTypes.oneOf(["image", "video"]).isRequired,
  index: PropTypes.number.isRequired,
  className: PropTypes.string,
  mediaClassName: PropTypes.string,
  actions: PropTypes.node,
  onClose: PropTypes.func,
  rounded: PropTypes.bool,
  fluid: PropTypes.bool,
  imageHeight: PropTypes.number
}

export default function PreviewMedia({
  preview,
  placeholder,
  ratio = "",
  type,
  index,
  className = "",
  mediaClassName = "",
  actions,
  onClose,
  rounded = true,
  fluid = false,
  imageHeight = 140
}) {
  const dispatch = useDispatch()
  const slides = useSelector((store) => store.lightbox.slides)

  const handleClick = () => {
    if (slides?.length) {
      dispatch(setActiveSlide(index))
    }
  }

  const classes = className ? `position-relative ${className}` : "position-relative"
  const buttonClasses = ["p-0 rounded", fluid || ratio ? "w-100" : "w-auto", ratio && `ratio ratio-${ratio}`].filter(Boolean).join(" ")

  const mediaClasses = ["object-fit-cover h-100 w-100", rounded && "rounded", !fluid && !ratio && "w-auto", mediaClassName]
    .filter(Boolean)
    .join(" ")

  const renderMediaContent = () => {
    if (type === "image") {
      return (
        <LazyLoadImage src={preview} height={imageHeight} className={mediaClasses} alt="image" placeholderSrc={placeholder} effect="blur" />
      )
    }

    if (type === "video") {
      return (
        <div className="position-relative w-100" style={{ height: "140px" }}>
          <video src={preview} className={mediaClasses} style={{ height: imageHeight }} controls={false} preload="metadata" muted />
          <Icon iconName="Play" className="position-absolute top-50 start-50 translate-middle text-white" width={30} height={30} />
        </div>
      )
    }

    return null
  }

  return (
    <div className={classes}>
      {actions && <div className={`position-absolute top-0 end-0 p-2 hstack gap-10 ${onClose ? "pe-15" : ""}`}>{actions}</div>}
      {onClose && (
        <Button
          color="ghost"
          size="icon"
          className="position-absolute top-0 end-0 z-1 m-n1 p-0 text-white shadow bg-transparent-hover"
          onClick={onClose}
        >
          <Icon iconName="CloseFill" width={20} height={20} style={{ backgroundColor: "white", borderRadius: "50%", color: "#1d72f4" }} />
        </Button>
      )}
      <Button type="button" color="ghost" className={buttonClasses} onClick={handleClick}>
        {renderMediaContent()}
      </Button>
    </div>
  )
}
